import './modal-body.scss';

function ModalBody({ ...props }) {
    return (
        <div className="modal-body">
            {props.children}
        </div>
    )
}

export default ModalBody;